/* eslint-disable react-hooks/rules-of-hooks */
"use client";

import {
  CardContainer,
  BreadCrumb,
  CardProps,
  Steps,
  Step,
} from "@/components/templates";
import styles from "./styles.module.scss";
import { FC } from "react";

export interface EntretienCreationProps {
  cards: CardProps[];
  text: string;
  steps: Step[];
  breadCrumbs: {
    url: string;
    label: string;
  }[];
  root: string;
  title: string;
}

export const EntretienCreation: FC<EntretienCreationProps> = ({
  cards,
  text,
  steps,
  breadCrumbs,
  root,
  title,
}) => {
  return (
    <>
      <div className={styles.entretien_conception}>
        <div className={styles.bread_crumb_container}>
          <BreadCrumb data={breadCrumbs} className={styles.bread_crumb} />
        </div>
        <div className={styles.title_and_paragraph}>
          <h1 className={"capitalize"}>{title}</h1>
          <div
            className={styles.text_container}
            dangerouslySetInnerHTML={{ __html: text }}
          ></div>
        </div>
        <div className={styles.steps_container_block}>
          <Steps steps={steps} />
        </div>
        <div className={styles.cards_container}>
          <CardContainer root={root} data={cards} />
        </div>
      </div>
    </>
  );
};
